export default __webpack_public_path__ + "assets/images/Payment_09.1de00c.png";